import { createApp } from "vue";
import App from "./App.vue";
import accessibleDialog, { classDrivenDialog } from "./accessibility/dialog";
import "./accessibility/chat";
import router from "./router";
import store from "./store";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import GoogleSignInPlugin from "vue3-google-signin"; // ⬅️ nuevo
import VueSplide from "@splidejs/vue-splide";
import "./style/tailwind.css";
import "./style/accessibility.css";

// (opcional) tu auto-logout
setTimeout(() => {
  localStorage.clear();
  location.reload();
}, 60 * 60 * 1000);

const app = createApp(App);
app.directive("accessible-dialog", accessibleDialog);
app.directive("class-dialog", classDrivenDialog);

app.use(store).use(router).use(VueSplide);

// 🔐 Inicializa Google Identity Services
app.use(GoogleSignInPlugin, {
  // ideal: usar variable de entorno
  // clientId: import.meta.env.VITE_GAUTH_CLIENT_ID,
  clientId: "601281298211-i5itp3i4kah1tfmkg25lh8mb1gtcu77k.apps.googleusercontent.com",
});

app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDFyow1ZryXoe6pXceS9v_nNVca_i6glcY",
    libraries: "places",
  },
});

app.mount("#app");
